import React, { useState, useEffect, useRef } from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import { Layout,  Spin, Select } from "antd";
import { getRefDetail } from '../../pages/Common/api';
const {Content} = Layout;

/** -------------------------------------------------------------------------- **/
function AnalysisRefDetail() { 
    const params = useParams();
    const contentRef = useRef(null); // DOM 요소에 직접 접근하기 위한 ref

    const { reportId, resultAssetcd } = params;
    const arrAssetcd = (resultAssetcd || "").split(",");
    
    const [spinflagMain,  setSpinflagMain] = useState(true); // 초기 로딩을 위해 true로 설정
    const [assetCd, setAssetCd] = useState(arrAssetcd[0]);
    
    // remark의 \n을 <br>로 바꾸기 위한 정규식
    // const reg = new RegExp(/\\n|\n/, "g"); // textarea에서는 불필요

    const findRefDetail = async (assetCd) => {
        if(!reportId || !assetCd) {
            if(contentRef.current) {
                contentRef.current.value = "보고서 ID 또는 자산 코드가 없습니다.";
            }
            setSpinflagMain(false);
            return;
        };

        setSpinflagMain(true);
        try {
            const response = await axios.get(getRefDetail(reportId, assetCd));
            if (contentRef.current) {
                if(response.data.data.length > 0 && response.data.data[0].remark){
                    // textarea의 value 속성을 사용하여 텍스트를 직접 설정합니다.
                    // 이 방식은 div의 innerHTML을 설정하는 것보다 훨씬 빠릅니다.
                    // \n 문자는 textarea에서 자동으로 줄바꿈 처리됩니다.
                    contentRef.current.value = response.data.data[0].remark;
                } else {
                    contentRef.current.value = "데이터 없음";
                }
            }
        } catch (error) {
            if (contentRef.current) {
                contentRef.current.value = `데이터를 불러오는 중 오류가 발생했습니다: ${error.message}`;
            }
            console.error("Error fetching ref detail:", error);
        } finally {
            setSpinflagMain(false);
        }
    }

    useEffect(() => {
        findRefDetail(assetCd);
    }, [assetCd]); // reportId는 변경되지 않으므로 의존성 배열에서 제외해도 무방

    const onSelectChange = (value) => {
        setAssetCd(value);
    }

    return (
        <Spin size={"large"}  tip={"Loading..."} spinning={spinflagMain}>
        <Content style={{ 'overflow': 'auto'}} >
            <div className='popup_header'>
                <div className='popup_title'>
                {reportId} :
                <Select value={assetCd} placeholder="자산 선택" onChange={onSelectChange}
                style={{"top":"-5px","left":"15px"}}>
                    {arrAssetcd.map((data) => (
                        <Select.Option key={data} value={data} label={data}>
                        {data}
                        </Select.Option>
                    ))}
                </Select>     
                <span style={{"position":"relative","left":"25px"}}>REF 상세내용 </span>
                </div>
            </div>    
            {/* 
              - ref를 사용하여 DOM에 직접 접근합니다.
              - React state에 큰 데이터를 저장하지 않음으로써 리렌더링 성능 저하를 방지합니다.
              - div 대신 textarea를 사용하여 대용량 텍스트 렌더링 성능을 개선합니다.
            */}
            <textarea 
                ref={contentRef} 
                readOnly 
                style={{ 
                    width: '98%',
                    height: "calc(100vh - 80px)", 
                    padding: "10px", 
                    overflowY: "auto",  
                    overflowX: "hidden", 
                    backgroundColor: "white",
                    border: '1px solid #d9d9d9',
                    borderRadius: '2px',
                    resize: 'none',
                    fontFamily: 'monospace' // 고정폭 글꼴으로 가독성 향상
                }} 
            />
        </Content>
        </Spin>

    );

}
export default AnalysisRefDetail;